import Vue from 'vue';
import Component from 'vue-class-component';

declare global {
    interface Window {
        grecaptcha?: {
            enterprise?: {
                ready: (callback: () => void) => void
                execute: (siteKey: string, options: { action: string }) => Promise<string>
            }
        }
    }
}

let enterpriseScriptPromise: Promise<void> | null = null

const loadEnterpriseRecaptcha = (siteKey: string): Promise<void> => {
    if (window.grecaptcha?.enterprise) return Promise.resolve()
    if (enterpriseScriptPromise) return enterpriseScriptPromise

    enterpriseScriptPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}&badge=bottomleft`
        script.async = true
        script.onload = () => resolve()
        script.onerror = () => {
            enterpriseScriptPromise = null
            reject(new Error('Failed to load reCAPTCHA Enterprise'))
        }
        document.head.appendChild(script)
    })

    return enterpriseScriptPromise
}

export interface RecaptchaResponse {
    RecaptchaResponse?: string
}

@Component
export default class RecaptchaMixin extends Vue {
    siteKey: string = '';
    mounted() {
        if (this.siteKey) {
            loadEnterpriseRecaptcha(this.siteKey)
            this.showCaptcha()
        }
    }
    hideCaptcha() {
        const captchaEl = document.getElementById('recaptcha-visible')
        if (captchaEl) captchaEl.remove()
    }
    showCaptcha(){
        document.head.insertAdjacentHTML('beforeend', '<style id="recaptcha-visible">.grecaptcha-badge{visibility:visible}</style>')
    }
    async getRecaptchaToken(action: string = 'newsletterSignupSubmit'): Promise<string> {
        await loadEnterpriseRecaptcha(this.siteKey)
        const enterprise = window.grecaptcha?.enterprise
        if (!enterprise) throw new Error('reCAPTCHA Enterprise is unavailable')

        await new Promise<void>((resolve) => enterprise.ready(resolve))
        return enterprise.execute(this.siteKey, { action })
    }
}
